<template>
	<div v-loading="loading" class="hotspot-panel" element-loading-background="rgba(0, 0, 0, 0.8)">
		<div v-if="lists.length == 0" class="hotspot-placeholder">暂无热点</div>
		<div v-else class="hotspot-list">
			<div v-for="item in lists" :key="item.id" class="item">
				<div class="icon-box">
          <div v-if="item.imageType == 4">--</div>
					<img v-else class="icon" :src="item.imagePreview | switchPreviewThumb(item.image)" />
				</div>
				<div class="title">{{ item.title }}</div>
				<div class="operate v-row">
					<div class="btn" @click="positionHotspot(item)">定位</div>
					<div class="line">|</div>
					<div class="btn" @click="editHotspot(item)">修改</div>
					<div class="line">|</div>
					<el-popconfirm title="确认删除?" @onConfirm="deleteHotSpot(item)">
						<div slot="reference" v-loading="item.deleteLoading" class="btn">
							删除
						</div>
					</el-popconfirm>
				</div>
			</div>
		</div>
		<div class="panel-footer">
			<div class="btn btn-save" @click="addHotspot">新增热点</div>
			<div class="btn btn-cancel" @click="$emit('update:show',false)">取消</div>
		</div>
		<spot-add-edit v-if="isShowAddEdit" :id="spotId" :show.sync="isShowAddEdit" />
	</div>
</template>

<script>
	import build from '../build';
	import {mapState, mapActions} from "vuex";
	import spotAddEdit from "./page-header-spot-add-edit";
	import defaultSpot from '../data/data-default-spot'

	export default {
		components: {spotAddEdit},

		filters: {
			switchPreviewThumb(preview, key) {
				let spot = defaultSpot.dynamic.find(item => item.key == key)
				return spot ? spot.thumb : preview
			}
		},

		props: {
			show: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				loading: false,
				isShowAddEdit: false,
				spotId: null
			};
		},

		computed: {
			...mapState("tour", ["krp", 'materialId', 'sceneDetail']),
			lists: function () {
				return this.sceneDetail.spotList
			}

		},

		methods: {

			...mapActions("tour", {
				actionGetSceneDetail: "getSceneDetail"
			}),

			//新增热点弹窗
			addHotspot() {
				this.spotId = null;
				this.isShowAddEdit = true;
			},

			//修改
			editHotspot(row) {
				window.krpjs.editHotSpot(row.id);
			},

			//删除热点
			async deleteHotSpot(row) {
				this.$set(row, "deleteLoading", true);
				try {
					await this.api.spot.delete({id: row.id});
					let name = `hotspot_${row.id}`;
					build.removeHotspots(this.krp, [name, name + '_placeholder', name + '_edit', name + '_delete', name + '_title', name + '_desc']);
					this.actionGetSceneDetail({materialId: this.materialId});
					this.$message.success("删除成功");
				} catch (e) {
					console.error(e);
				}
				this.$set(row, "deleteLoading", false);
			},

			//定位热点
			positionHotspot(row) {
				let fov = this.krp.get("view.fov");
				let spotName = `hotspot_${row.id}`;
				if (row.imageType == 3) {
					let dom = this.krp.get(`hotspot[${spotName}].sprite`);
					let rect = dom.getBoundingClientRect();
					this.krp.call(`set(x,${rect.x})`);
					this.krp.call(`set(y,${rect.y})`);
					this.krp.call(`screentosphere(x,y, h,v)`);
					let ath = this.krp.get(`h`);
					let atv = this.krp.get(`v`);
					this.krp.call(`lookto(${ath},${atv},${fov},smooth())`);
				} else {
					this.krp.call(`looktohotspot(${spotName},${fov},smooth())`);
				}
			},


		},


	};
</script>

<style lang="scss" scoped>
	.hotspot-panel {
		position: absolute;
		top: 60px;
		right: 20px;
		background: rgba(0, 0, 0, 0.6);
		border-radius: 4px;
		width: 350px;
		color: #fff;
	}

	.hotspot-list {
		padding: 10px;
		min-height: 200px;
		max-height: 500px;
		overflow-y: auto;
	}

	.hotspot-list .item {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
		border: 1px solid #ddd;
		padding: 10px;

		&:hover {
			border-color: #1e9fffcc;
		}
	}

	.hotspot-list .item .icon-box {
		width: 50px;
	}

	.hotspot-list .item .icon {
		display: block;
		height: 30px;
		max-width: 100%;
	}

	.hotspot-list .item .title {
		flex: 1;
		padding: 0 20px 0 10px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 12px;
	}

	.hotspot-list .item .operate {
		font-size: 12px;
	}

	.hotspot-list .item .operate .line {
		margin: 0 3px;
	}

	.hotspot-list .item .operate .btn {
		cursor: pointer;
		user-select: none;

		&:hover {
			font-weight: bold;
		}
	}

	.hotspot-placeholder {
		padding: 100px;
		text-align: center;
	}

	.panel-footer {
		display: flex;
	}

	.panel-footer .btn {
		flex: 1;
		height: 40px;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

		&:hover {
			opacity: 0.8;
		}
	}

	.panel-footer .btn-save {
		background: #006ab1;
	}

	.panel-footer .btn-cancel {
		background: #9e9e9e;
	}
</style>
